import { render, staticRenderFns } from "./IosPrompt.vue?vue&type=template&id=ea04559a"
import script from "./IosPrompt.vue?vue&type=script&lang=js"
export * from "./IosPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports